import { FunctionalComponent, h } from '@stencil/core';
import get from 'lodash/get'
import { AppMedia, AppLink } from './'

interface AppProduct {
    Title: string;
    Description?: string;
    CTA?: any;
    Image?: any;
    Tags?: any;
    ShowCompare?: boolean;
    IsCompare?: boolean;
    OnCompare?: any;
    Eager?:boolean;
}


export const AppProduct: FunctionalComponent<AppProduct> = ({ Title, Description, Image, Tags, CTA, IsCompare = false, ShowCompare = false, OnCompare, Eager }) => {

    const tagAttributes = {};
    if (get(Tags, 'data[0]')) {
        Tags.data.forEach(({ attributes: { Group, Label } }) => {
            tagAttributes[`data-${Group}`] ? tagAttributes[`data-${Group}`] += `,${Label}` : tagAttributes[`data-${Group}`] = Label
        })
    }

    // Set title to searchable
    tagAttributes[`data-title`] = Title.toLowerCase();

    return (
        <div id={`Product-${Title}`} key={Title} {...tagAttributes}>
            <div class="uk-card uk-text-center">
                <div class="uk-card-media-top uk-padding uk-padding-remove-bottom">
                    <AppMedia className='uk-width-2-3 uk-width-1-1@s' size="(max-width: 638px) 50vw, (max-width: 958px) 50vw, 25vw" media={Image} eager={Eager} />
                </div>
                <div>
                    <h3 class="uk-heading-small uk-margin-small-bottom wsio-darker-green">{Title}</h3>
                    <p class="uk-margin-remove-top uk-margin-remove-bottom wsio-dark-grey wsio-clamp-4">{Description}</p>
                    <div class="uk-flex uk-flex uk-flex-middle uk-margin-top">
                        {ShowCompare ? <div class='uk-flex-1'><button onClick={OnCompare} class={`uk-button uk-margin-small-right ${IsCompare ? 'uk-button-secondary' : 'uk-button-default'}`}>{IsCompare ? 'Added' : 'Compare'}</button></div> : ''}
                        {
                            CTA && CTA.URL ? 
                            <div class="uk-flex-1">
                                <AppLink className='uk-button uk-button-primary' data={CTA} />
                            </div>
                            :
                            false
                        }
                    </div>
                </div>
            </div>
        </div>
    )
};